import React from 'react';
import { Select as AntSelect } from 'antd';
import { ReactComponent as ChevronDown } from 'assets/icons/chevron-down.svg';
import PropTypes from 'prop-types';
import { Label } from 'components';

const { Option } = AntSelect;

const Select = ({
  options = [],
  label,
  title,
  bold = false,
  containerClassName,
  asterisk = false,
  allowClear = false,
  ...rest
}) => {
  return (
    <div className={`custom-select ${containerClassName}`}>
      {/* <div
        className={`text-white-space custom-select__title__${
          bold ? 'bold mb-2' : 'normal mb-1'
        }`}
      >
        {title}
      </div> */}
      <div className={`text-white-space ${bold ? "mb-1" : ""}`}>
        {<Label label={label} asterisk={asterisk}/>}
      </div>
      <AntSelect {...rest} allowClear={true} suffixIcon={<ChevronDown style={{marginRight:"-0.32rem", marginBottom:"-0.375rem", width:"18px"}}/>}>
        {options &&
          options.map(({ label, value, disabled }, index) => (
            <Option key={index} value={value} disabled={disabled}>
              {label}
            </Option>
          ))}
      </AntSelect>
    </div>
  );
};

Select.propTypes = {
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
  title: PropTypes.string.isRequired,
  bold: PropTypes.bool,
  containerClassName: PropTypes.string,
};

export default Select;
